<template>
<div class="row">
  <div class="col-xs-12">
    <ParticipationTermGeneric
      v-if="companyTerms === 'generic'"
      :ticket="ticket"
      :loading="loading"
    />
    <partitipation-term-enel
      v-if="state === 'CE' && companyTerms === 'enel'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-enel-go
      v-if="state === 'GO'&& companyTerms === 'enel'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-cemar
      v-if="state === 'MA'&& companyTerms === 'cemar'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-iasc-ma
      v-if="state === 'MA' && companyTerms === 'iasc'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-iasc-pi
      v-if="state === 'PI' && companyTerms === 'iasc'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-equatorial-pi
      v-if="state === 'PI' && companyTerms === 'equatorial'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-iasc-al
      v-if="state === 'AL' && companyTerms === 'iasc'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-energisa-pb
      v-if="state === 'PB' && companyTerms === 'energisa-paraiba'"
      :ticket="ticket"
      :loading="loading"
    />

    <participation-term-energisa-borborema-pb
      v-if="state === 'PB' && companyTerms === 'energisa-borborema'"
      :ticket="ticket"
      :loading="loading"
    />

    <ParticipationTermCelpa
      v-if="state === 'PA' && companyTerms === 'celpa'"
      :ticket="ticket"
      :loading="loading"
    />
    <ParticipationTermCelpaJurunas
      v-if="state === 'PA' && companyTerms === 'celpa-jurunas'"
      :ticket="ticket"
      :loading="loading"
    />

  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ParticipationTermCemar from './Cemar/ParticipationTermCemar'
import ParticipationTermEnelGo from './EnelGo/ParticipationTermEnelGo'
import PartitipationTermEnel from './EnelCe/ParticipationTermEnelCe'
import ParticipationTermIascPi from './IascPi/ParticipationTermIasc'
import ParticipationTermIascMa from './IascMa/ParticipationTermIasc'
import ParticipationTermIascAl from './IascAl/ParticipationTermIasc'
import ParticipationTermEnergisaPb from './EnergisaPb/ParticipationTermEnergisaPb'
import ParticipationTermEnergisaBorboremaPb from './EnergisaBorboremaPb/ParticipationTermEnergisaBorboremaPb'
import ParticipationTermCelpa from './Celpa/ParticipationTermCelpa'
import ParticipationTermEquatorialPi from './EquatorialPi/ParticipationTermEquatorialPi'
import ParticipationTermCelpaJurunas from './CelpaJurunas/ParticipationTermCelpaJurunas'
import ParticipationTermGeneric from '../../../components/Trg/Terms/ParticipationTermGeneric'

export default {
  name: 'ParticipationTerm',

  components: {
    ParticipationTermGeneric,
    ParticipationTermCelpaJurunas,
    ParticipationTermEquatorialPi,
    ParticipationTermCemar,
    ParticipationTermEnelGo,
    PartitipationTermEnel,
    ParticipationTermIascMa,
    ParticipationTermIascAl,
    ParticipationTermIascPi,
    ParticipationTermEnergisaPb,
    ParticipationTermEnergisaBorboremaPb,
    ParticipationTermCelpa
  },

  props: {
    ticket: {
      required: true
    },
    loading: {
      required: true
    }
  },

  computed: {
    ...mapGetters('project', {
      project: 'project'
    }),
    state: function () {
      return this.project.state
    },
    companyTerms: function () {
      return this.ticket.event.doc.companyTerms
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/ParticipationTerm.vue